<template>
  <!-- La raíz queda en su lugar (Vue la usa de referencia al redibujar el padre); solo el
       botón se muda a <body>. -->
  <span class="m-fab-anchor">
  <button
    ref="fab"
    type="button"
    class="m-fab"
    :aria-label="label"
    :title="label"
    @click="$emit('click', $event)"
  >
    <i :class="['fas', 'fa-' + icon]" aria-hidden="true"></i>
  </button>
  </span>
</template>

<script>
/**
 * Botón flotante de la acción principal (crear), abajo a la derecha, con el primario del
 * tenant. Se monta en <body>: la transición de entrada de las rutas (animate.css) deja un
 * transform en el contenedor de la página y un position:fixed adentro dejaría de ir pegado
 * a la pantalla.
 */
export default {
  name: "MobileFab",
  props: {
    icon: { type: String, default: "plus" },
    label: { type: String, required: true },
  },
  mounted() {
    document.body.appendChild(this.$refs.fab);
  },
  beforeDestroy() {
    const fab = this.$refs.fab;
    if (fab && fab.parentNode) fab.parentNode.removeChild(fab);
  },
};
</script>

<style scoped>
.m-fab-anchor {
  display: none;
}
.m-fab {
  position: fixed;
  right: 1rem;
  bottom: calc(1rem + env(safe-area-inset-bottom));
  z-index: 1030; /* el de los fijos de Bootstrap: debajo de modales y hojas */
  width: 3.5rem;
  height: 3.5rem;
  border: 0;
  border-radius: 50%;
  background: var(--bs-primary);
  color: var(--bs-white);
  font-size: 1.3rem;
  box-shadow: var(--bs-box-shadow);
}
.m-fab:active {
  transform: scale(0.96);
}
</style>
